const ICON_WRAPPER_PROPS = {
  $transform: 'scale(1.1)',
  $margin: '0 0 16px -8px',
};

export { ICON_WRAPPER_PROPS };
